import { useDefaultNavigationItems, useAdminNavigationItems } from './hooks';

import type { NavigationItem } from 'layout/MainLayout/components/Sidebar/types';

export const useNavigationItemsConfig = (): NavigationItem[] => {
  const adminNavigationItems = useAdminNavigationItems();
  const defaultNavigationItems = useDefaultNavigationItems();

  return [...adminNavigationItems, ...defaultNavigationItems];
};
